import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { FeeReportModal } from "./FeeReportModal";
import { HTMLAttributes } from "react";

export const FeeReportButton: React.FC<HTMLAttributes<HTMLElement>> = observer(({ ...props }) => {
  const { actionModals } = useStores();

  const feeReportHandler = () => {
    actionModals.open(() => <FeeReportModal />, {
      width: "600px",
      noValidation: true,
      isOverlayClose: false,
      title: `Отчет о пополнениях на комиссию БЧ`,
      onClose: () => actionModals.closeAll(),
    });
  };

  return (
    <CustomButton onClick={feeReportHandler} type="default" className={props.className}>
      Отчет о пополнениях на комиссию БЧ
    </CustomButton>
  );
});
